import { render, staticRenderFns } from "./WelcomeMenu.vue?vue&type=template&id=2c696543&"
import script from "./WelcomeMenu.vue?vue&type=script&lang=js&"
export * from "./WelcomeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports